import { UseUserStorageApi } from "fe-web-components/userStorage/useUserStorage";
import { UserStorageKey } from "fe-web-components/userStorage/userStorageKey";

export function setCurrentCase(caseId, etag, userStorage: UseUserStorageApi) {
  userStorage.writeToStorage(UserStorageKey.LastCaseId, caseId);
  userStorage.writeToStorage(UserStorageKey.LastCaseEtag, etag);
}

export function removeCurrentCase(userStorage: UseUserStorageApi) {
  userStorage.writeToStorage(UserStorageKey.LastCaseId, "");
  userStorage.writeToStorage(UserStorageKey.LastCaseEtag, "");
}

export function getCurrentCase(userStorage: UseUserStorageApi) {
  const caseId: string = userStorage.readFromStorage(UserStorageKey.LastCaseId);
  const etag: string = userStorage.readFromStorage(UserStorageKey.LastCaseEtag);
  return { caseId, etag };
}
